import { addQueryParameters } from 'common/src/vtj/browser/query-param.util'
import React from 'react'
import {
  Button,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Paragraph,
} from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

const DEFAULT_LOGIN_PATH = '/auth/suomifi/login'

function loadPage(path: string) {
  return () => {
    window.document.location.href = path
    return false
  }
}

interface SessionTimeoutErrorDialogContentProps {
  dataTestId: string
  lang: string
}

export const SessionTimeoutErrorDialogContent = ({
  dataTestId,
  lang,
}: SessionTimeoutErrorDialogContentProps): React.JSX.Element => {
  const labelledby = 'timed-out-error-title'
  const describedby = 'timed-out-error-description'
  return (
    <React.Fragment>
      <ModalContent
        role="alert"
        aria-labelledby={labelledby}
        aria-describedby={describedby}
      >
        <ModalTitle
          id={labelledby}
          data-test-id={`${dataTestId}-sessionTimeoutErrorHeader`}
        >
          <LocalizedString stringKey="sessionTimeoutErrorTitle" />
        </ModalTitle>
        <Paragraph id={describedby}>
          <LocalizedString stringKey="sessionTimeoutErrorContent" />
        </Paragraph>
      </ModalContent>
      <ModalFooter>
        <Button
          data-test-id={`${dataTestId}-login-button`}
          onClick={loadPage(
            addQueryParameters(DEFAULT_LOGIN_PATH, {
              lang,
              RelayState: `/${lang}`,
            })
          )}
        >
          <LocalizedString stringKey="errorPageLoginButtonLabel" />
        </Button>
        <Button
          data-test-id={`${dataTestId}-main-page-button`}
          variant="secondary"
          onClick={loadPage(`/${lang}/`)}
        >
          <LocalizedString stringKey="errorPageLandingPageLinkLabel" />
        </Button>
      </ModalFooter>
    </React.Fragment>
  )
}
